/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Template predefinito per il bootstrap di un TipoPratica
 */
export enum TipoPraticaTemplate {

    MENSA_ESEMPIO = 'MENSA_ESEMPIO',

    MENSA_GESTIONE_MANUALE = 'MENSA_GESTIONE_MANUALE',

    BUONI_LIBRO_ESEMPIO = 'BUONI_LIBRO_ESEMPIO',

    CEDOLE_LIBRARIE_ESEMPIO = 'CEDOLE_LIBRARIE_ESEMPIO',

    BUONI_SPESA_ESEMPIO = 'BUONI_SPESA_ESEMPIO',

    PACCO_ALIMENTARE_ESEMPIO = 'PACCO_ALIMENTARE_ESEMPIO',

    AGEVOLAZIONE_VOUCHER = 'AGEVOLAZIONE_VOUCHER',

    AGEVOLAZIONE_TRIBUTO = 'AGEVOLAZIONE_TRIBUTO',

    AGEVOLAZIONE_SERVIZIO_SCUOLA = 'AGEVOLAZIONE_SERVIZIO_SCUOLA'
}

